import { render, staticRenderFns } from "./activity-xfans_joy.vue?vue&type=template&id=702245a0&scoped=true&"
import script from "./activity-xfans_joy.vue?vue&type=script&lang=js&"
export * from "./activity-xfans_joy.vue?vue&type=script&lang=js&"
import style0 from "./activity-xfans_joy.vue?vue&type=style&index=0&id=702245a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702245a0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Atlas: require('/var/jenkins_home/workspace/prod-web-xfans/components/atlas.vue').default})
